module.exports = "https://cdn.realtymogul.com/static/media/img_hero_ContactUs.139588ab.jpg";